import React from 'react';
import { ValidationResult } from 'src/easyclaim.api.client.typescript/src';
import styled, { css } from 'styled-components';

import { IconCheck, IconError, IconWarning, QuestionMark } from '../../easyclaim.app.assets/index';
import { FadeIn } from '../animations/FadeIn';

export const FeedbackIcon = (props: { validationResult?: ValidationResult }) => {
	return props.validationResult === ValidationResult.Error ? (
		<>
			<FeedbackErrorIcon className="FeedbackErrorIcon" />
			<FeedbackErrorTriangleIcon className="FeedbackErrorTriangleIcon" />
		</>
	) : props.validationResult === ValidationResult.Warning ? (
		<FeedbackWarningIcon className="FeedbackWarningIcon" />
	) : (
		<FeedbackOkIcon className="FeedbackSuccessIcon" />
	);
};

const FeedbackOkIcon = styled(IconCheck)`
	color: ${(p) => p.theme.colors.success};
	height: 1.2rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
	vertical-align: text-bottom;
`;

const FeedbackWarningIcon = styled(QuestionMark)`
	color: ${(p) => p.theme.colors.warning};
	height: 0.75rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
	vertical-align: text-top;
`;

const FeedbackErrorIcon = styled(IconError)`
	color: ${(p) => p.theme.colors.danger};
	height: 0.75rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
	vertical-align: baseline;
`;

const FeedbackErrorTriangleIcon = styled(IconWarning)`
	color: ${(p) => p.theme.colors.danger};
	vertical-align: middle;
	height: 1.5rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
`;
